import { WheelColor, WheelColorsList } from '../interfaces/wheel.interface';

export const WHEEL_COLORS: WheelColorsList = {
  gray: [
    2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40,
    42, 44, 46, 48, 50, 52,
  ],
  red: [3, 5, 7, 13, 15, 17, 23, 25, 27, 29, 31, 37, 39, 41, 47, 49, 51],
  blue: [1, 9, 11, 19, 21, 33, 35, 43, 45, 53],
  gold: [0],
};

export const WHEEL_SETTINGS = {
  ROLL_DURATION: 9000,
  ROLL_RESULTS: 3000,
  ROUND_DURATION: 15000,
};

export const WHEEL_MULTIPLIERS: Record<WheelColor, number> = {
  gray: 2,
  red: 3,
  blue: 5,
  gold: 50,
};
